<ion-app [ngClass]="{'web-environment': environment.platform === 'web'}">
  <ion-router-outlet></ion-router-outlet>
</ion-app>
